import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { UsersService } from "./UsersService";

//Agents
export const GetAllDownlines = createAsyncThunk(
  "ls/GetAllDownlines",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().GetAllDownlines(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

// GetAggregatorDownlines
export const GetAggregatorDownlines = createAsyncThunk(
  "ls/GetAggregatorDownlines",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().GetAggregatorDownlines(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

// GetAllAggregators
export const GetAllAggregators = createAsyncThunk(
  "ls/GetAllAggregators",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().GetAllAggregators(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

// GellDownlineById
export const GetDownlineById = createAsyncThunk(
  "ls/GetDownlineById",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().GetDownlineById(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

// SuperdealerDetails
export const SuperdealerDetails = createAsyncThunk(
  "ls/SuperdealerDetails",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().SuperdealerDetails(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

export const GetAggregatorById = createAsyncThunk(
  "ls/GetAggregatorById",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().GetAggregatorById(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

export const GetAggregatorProducts = createAsyncThunk(
  "ls/GetAggregatorProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().GetAggregatorProducts(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

export const GetDownlineProducts = createAsyncThunk(
  "ls/GetDownlineProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().GetDownlineProducts(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

// ActivateDownlineProduct
export const ActivateDownlineProduct = createAsyncThunk(
  "ls/ActivateDownlineProduct",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().ActivateDownlineProduct(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

export const DeactivateDownlineProduct = createAsyncThunk(
  "ls/DeactivateDownlineProduct",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await UsersService.usersModule().DeactivateDownlineProduct(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

export const GetSuperDealerProducts = createAsyncThunk(
  "ls/GetSuperDealerProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().GetSuperDealerProducts(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

export const SuperdealerAgents = createAsyncThunk(
  "ls/SuperdealerAgents",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().SuperdealerAgents(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const SingleSuperdealerAgents = createAsyncThunk(
  "ls/SingleSuperdealerAgents",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().SingleSuperdealerAgents(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.response;
    }
  }
);

export const UpdateSuperdealerAgent = createAsyncThunk(
  "ls/UpdateSuperdealerAgent",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().UpdateSuperdealerAgents(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const GetSuperdealerAgentProduct = createAsyncThunk(
  "ls/GetSuperdealerAgentProduct",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await UsersService.usersModule().GetSuperdealerAgentsProducts(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

//Resellers

export const SuperdealerResellers = createAsyncThunk(
  "ls/SuperdealerResellers",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().SuperdealerResellers(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const SingleSuperdealerResellers = createAsyncThunk(
  "ls/SingleSuperdealerResellers",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await UsersService.usersModule().SingleSuperdealerResellers(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const UpdateSuperdealerReseller = createAsyncThunk(
  "ls/UpdateSuperdealerReseller",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await UsersService.usersModule().UpdateSuperdealerReseller(payload);
      toast.success("Profile updated successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      toast.error("Profile update failed");
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const GetSuperdealerResellerProducts = createAsyncThunk(
  "ls/GetSuperdealerResellerProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await UsersService.usersModule().GetSuperdealerResellerProducts(
          payload
        );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const ListCustomers = createAsyncThunk(
  "ls/GetSuperdealerResellerProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().ListCustomers(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const ListMerchants = createAsyncThunk(
  "ls/ListMerchants",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().ListMerchants(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const ListTerminals = createAsyncThunk(
  "ls/ListTerminals",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().ListTerminals(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const ListCustomersWallets = createAsyncThunk(
  "ls/ListCustomersWallets",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().ListCustomerWallets(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const BulkUploadAgent = createAsyncThunk(
  "ls/AddContactPerson",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().BulkUploadAgent(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const AgentSearch = createAsyncThunk(
  "ls/AddContactPerson",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().AgentSearch(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const getAllProducts = createAsyncThunk(
  "ls/getAllProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().getProducts(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const OnboardAgent = createAsyncThunk(
  "ls/OnboardAgent",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().OnboardAgent(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const ActivateCustomers = createAsyncThunk(
  "ls/ActivateCustomers",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().ActivateCustomers(
        value
      );
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const DeactivateCustomers = createAsyncThunk(
  "ls/DeactivateCustomers",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().DeactivateCustomers(
        value
      );
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// AddMoreProducts
export const AddMoreProducts = createAsyncThunk(
  "ls/AddMoreProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().AddMoreProducts(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// CustomerProducts
export const CustomerProductsAgent = createAsyncThunk(
  "ls/CustomerProductsAgent",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().CustomerProductsAgent(
        value
      );
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// CustomerProducts
export const CustomerProductsResseller = createAsyncThunk(
  "ls/CustomerProductsResseller",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response =
        await UsersService.usersModule().CustomerProductsResseller(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// CustomerProducts
export const CustomerProductsRessellerAndAgent = createAsyncThunk(
  "ls/CustomerProductsRessellerAndAgent",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response =
        await UsersService.usersModule().CustomerProductsRessellerAndAgent(
          value
        );
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// UpdateCustomerProducts
export const UpdateCustomerProducts = createAsyncThunk(
  "ls/UpdateCustomerProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().UpdateCustomerProducts(
        value
      );
      toast.success("Product updated successfully");
      return response.data;
    } catch (error) {
      toast.error("Product update failed");
      return error?.response;
    }
  }
);

// UpdateCustomerCommission
export const UpdateCustomerCommission = createAsyncThunk(
  "ls/UpdateCustomerCommission",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response =
        await UsersService.usersModule().UpdateCustomerCommission(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// UpdateCommission
export const UpdateCommission = createAsyncThunk(
  "ls/UpdateCommission",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().UpdateCommission(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const EnableAction = createAsyncThunk(
  "ls/EnableAction",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().EnableAction(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const DisableAction = createAsyncThunk(
  "ls/DisableAction",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().DisableAction(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// FLEXMONIE *****************************

// ValidateCustomer
export const ValidateCustomer = createAsyncThunk(
  "ls/ValidateCustomer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().ValidateCustomer(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

// OnboarDownline
export const OnboarDownline = createAsyncThunk(
  "ls/OnboarDownline",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const value = payload;
    try {
      const response = await UsersService.usersModule().OnboarDownline(value);
      return response.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const CurrentUser = createAsyncThunk(
  "ls/CurrentUser",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await UsersService.usersModule().CurrentUser(payload);
      localStorage.setItem(
        "user_profile",
        JSON.stringify(response?.data?.data, null, 2)
      );
      localStorage.setItem(
        "onboardingStatus",
        JSON.stringify(response?.data?.data?.onboardingStatus, null, 2)
      );
      toast.success(response?.message);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

export const UsersSlice = createSlice({
  name: "Users",
  initialState: "",
  extraReducers: {
    // FLEXMONIE ***************************
    [ValidateCustomer.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ValidateCustomer.fulfilled]: (state, action) => {
      return { ...state, ValidateCustomer: action.payload, loading: false };
    },

    [ValidateCustomer.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [CurrentUser.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [CurrentUser.fulfilled]: (state, action) => {
      return { ...state, CurrentUser: action.payload, loading: false };
    },

    [CurrentUser.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetAllDownlines.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [GetAllDownlines.fulfilled]: (state, action) => {
      return { ...state, GetAllDownlines: action.payload, loading: false };
    },

    [GetAllDownlines.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    // GetAggregatorDownlines
    [GetAggregatorDownlines.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [GetAggregatorDownlines.fulfilled]: (state, action) => {
      return { ...state, GetAggregatorDownlinesPayload: action.payload, loading: false };
    },

    [GetAggregatorDownlines.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetAllAggregators.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [GetAllAggregators.fulfilled]: (state, action) => {
      return { ...state, GetAllAggregators: action.payload, loading: false };
    },

    [GetAllAggregators.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetDownlineById.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [GetDownlineById.fulfilled]: (state, action) => {
      return { ...state, GetDownlineById: action.payload, loading: false };
    },

    [GetDownlineById.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetAggregatorById]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [GetAggregatorById.fulfilled]: (state, action) => {
      return { ...state, GetAggregatorById: action.payload, loading: false };
    },

    [GetAggregatorById.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [SuperdealerDetails.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [SuperdealerDetails.fulfilled]: (state, action) => {
      return { ...state, SuperdealerDetails: action.payload, loading: false };
    },

    [SuperdealerDetails.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetAggregatorProducts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [GetAggregatorProducts.fulfilled]: (state, action) => {
      return {
        ...state,
        GetAggregatorProducts: action.payload,
        loading: false,
      };
    },

    [GetAggregatorProducts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetDownlineProducts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [GetDownlineProducts.fulfilled]: (state, action) => {
      return { ...state, GetDownlineProducts: action.payload, loading: false };
    },

    [GetDownlineProducts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetSuperDealerProducts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [GetSuperDealerProducts.fulfilled]: (state, action) => {
      return {
        ...state,
        GetSuperDealerProducts: action.payload,
        loading: false,
      };
    },

    [GetSuperDealerProducts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    // FLEXMONIE *************************

    [DisableAction.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [DisableAction.fulfilled]: (state, action) => {
      return { ...state, DisableAction: action.payload, loading: false };
    },
    [DisableAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [EnableAction.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [EnableAction.fulfilled]: (state, action) => {
      return { ...state, EnableAction: action.payload, loading: false };
    },
    [EnableAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [UpdateCustomerCommission.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [UpdateCustomerCommission.fulfilled]: (state, action) => {
      return {
        ...state,
        UpdateCustomerCommission: action.payload,
        loading: false,
      };
    },
    [UpdateCustomerCommission.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [UpdateCommission.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [UpdateCommission.fulfilled]: (state, action) => {
      return {
        ...state,
        UpdateCommission: action.payload,
        loading: false,
      };
    },
    [UpdateCommission.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [UpdateCustomerProducts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [UpdateCustomerProducts.fulfilled]: (state, action) => {
      return {
        ...state,
        UpdateCustomerProducts: action.payload,
        loading: false,
      };
    },
    [UpdateCustomerProducts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [CustomerProductsAgent.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CustomerProductsAgent.fulfilled]: (state, action) => {
      return { ...state, CustomerProducts: action.payload, loading: false };
    },
    [CustomerProductsAgent.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [CustomerProductsResseller.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CustomerProductsResseller.fulfilled]: (state, action) => {
      return { ...state, CustomerProducts: action.payload, loading: false };
    },
    [CustomerProductsResseller.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    // CustomerProductsRessellerAndAgent
    [CustomerProductsRessellerAndAgent.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CustomerProductsRessellerAndAgent.fulfilled]: (state, action) => {
      return { ...state, CustomerProducts: action.payload, loading: false };
    },
    [CustomerProductsRessellerAndAgent.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [AddMoreProducts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [AddMoreProducts.fulfilled]: (state, action) => {
      return { ...state, AddMoreProducts: action.payload, loading: false };
    },
    [AddMoreProducts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [DeactivateCustomers.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [DeactivateCustomers.fulfilled]: (state, action) => {
      return { ...state, DeactivateCustomers: action.payload, loading: false };
    },
    [DeactivateCustomers.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActivateCustomers.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ActivateCustomers.fulfilled]: (state, action) => {
      return { ...state, ActivateCustomers: action.payload, loading: false };
    },
    [ActivateCustomers.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ListCustomers.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ListCustomers.fulfilled]: (state, action) => {
      return { ...state, ListAllCustomers: action.payload, loading: false };
    },
    [ListCustomers.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    // ListMerchants
    [ListMerchants.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ListMerchants.fulfilled]: (state, action) => {
      return { ...state, ListAllMerchants: action.payload, loading: false };
    },
    [ListMerchants.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    // ListTerminals
    [ListTerminals.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ListTerminals.fulfilled]: (state, action) => {
      return { ...state, ListAllTerminals: action.payload, loading: false };
    },
    [ListTerminals.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [OnboardAgent.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [OnboardAgent.fulfilled]: (state, action) => {
      return { ...state, OnboardAgents: action.payload, loading: false };
    },
    [OnboardAgent.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [getAllProducts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [getAllProducts.fulfilled]: (state, action) => {
      return { ...state, Products: action.payload, loading: false };
    },
    [getAllProducts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [AgentSearch.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [AgentSearch.fulfilled]: (state, action) => {
      return { ...state, AgentVerify: action.payload, loading: false };
    },
    [AgentSearch.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [BulkUploadAgent.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [BulkUploadAgent.fulfilled]: (state, action) => {
      return { ...state, BulkUploadAgents: action.payload, loading: false };
    },
    [BulkUploadAgent.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    //Agents
    [SuperdealerAgents.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [SuperdealerAgents.fulfilled]: (state, action) => {
      return { ...state, superdealerAgents: action.payload, loading: false };
    },
    [SuperdealerAgents.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [SingleSuperdealerAgents.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [SingleSuperdealerAgents.fulfilled]: (state, action) => {
      return { ...state, agent: action.payload, loading: false };
    },
    [SingleSuperdealerAgents.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [UpdateSuperdealerAgent.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [UpdateSuperdealerAgent.fulfilled]: (state, action) => {
      return { ...state, updatedAgent: action.payload, loading: false };
    },
    [UpdateSuperdealerAgent.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetSuperdealerAgentProduct.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [GetSuperdealerAgentProduct.fulfilled]: (state, action) => {
      return { ...state, agentProduct: action.payload, loading: false };
    },
    [GetSuperdealerAgentProduct.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    //Resellers

    [SuperdealerResellers.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    [SuperdealerResellers.fulfilled]: (state, action) => {
      return { ...state, superdealerResellers: action.payload, loading: false };
    },
    [SuperdealerResellers.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    [SingleSuperdealerResellers.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [SingleSuperdealerResellers.fulfilled]: (state, action) => {
      return { ...state, reseller: action.payload, loading: false };
    },
    [SingleSuperdealerResellers.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [UpdateSuperdealerReseller.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [UpdateSuperdealerReseller.fulfilled]: (state, action) => {
      return { ...state, updatedReseller: action.payload, loading: false };
    },
    [UpdateSuperdealerReseller.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    [GetSuperdealerResellerProducts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [GetSuperdealerResellerProducts.fulfilled]: (state, action) => {
      return { ...state, resellerProducts: action.payload, loading: false };
    },
    [GetSuperdealerResellerProducts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ListCustomersWallets.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ListCustomersWallets.fulfilled]: (state, action) => {
      return { ...state, customerWallets: action.payload, loading: false };
    },
    [ListCustomersWallets.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});

export default UsersSlice.reducer;
